module.exports = __webpack_public_path__ + "img/Osidex-Stream-140-X-42.1608a70a.svg";